import { useEffect } from 'react';

const GOOGLE_API_URL = 'https://maps.googleapis.com/maps/api/js';

const useGoogleAutocompleteScript = () => {
  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'google-autocomplete';
      script.src = `${GOOGLE_API_URL}?key=
        ${process.env.GOOGLE_LOCATION_API_KEY}&libraries=places`;
      document.getElementsByTagName('body')[0].appendChild(script);
    }
  }, []);
};

export default useGoogleAutocompleteScript;
